module.exports = __webpack_public_path__ + "static/media/low-fuel.1f9d8fab.svg";